var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"machine-detail"},[_c('b-row',[_c('b-col',[(_vm.detalles)?_c('b-table',{ref:"tableMachineDetail",attrs:{"fields":_vm.fields,"items":_vm.detalles,"empty-text":_vm.$t('label.noData'),"hover":"","show-empty":"","small":"","borderless":""}}):_vm._e()],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }